import { Layout, Menu } from 'antd';
import styled from 'styled-components';

export const StyledMenu = styled(Menu)`
  height: 100%;
  background: #f7f7f7;
  .ant-menu-item {
    color: #525356;
    &:hover {
      color: #669137 !important;
      background: rgba(102, 145, 55, 0.2) !important;
    }
  }
  .ant-menu-item-selected {
    color: #669137;
    background: rgba(102, 145, 55, 0.2);
  }
`;

export const StyledContent = styled(Layout.Content)`
  // background: #fff;
`;
